import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import {
  Checkbox,
  Button,
  FormControl,
  FormGroup,
  TextField,
  FormControlLabel,
  Typography,
  Snackbar,
  InputAdornment,
} from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { action } from 'mobx';
import { addMessageEntry } from '../firebaseConnection/database';
import { Message } from '../types/transport';
import { Role } from '../store/NewsStore';

const NotificationsPage = observer((): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const messageData = useLocalObservable<Message>(() => ({
    title: '',
    text: '',
    link: '',
    createdAt: Number(new Date()),
    architect: false,
    entrepreneur: false,
    handyman: false,
    tradingPartner: false,
  }));

  const addNotificationEntry = () => {
    if (messageData.link === '') {
      delete messageData.link;
    } else {
      messageData.link = `https://${messageData.link}`;
    }
    try {
      addMessageEntry(messageData);
      setOpen(true);
      setMessage(`Success`);
    } catch (e) {
      setOpen(true);
      setMessage(`Error: ${e}`);
    }
  };

  const roleNames = [
    'Architekt',
    'Fachunternehmer',
    'Heimwerker',
    'Handelspartner',
  ];

  return (
    <Container sx={{ width: `calc(100% - ${240}px)`, ml: `${240}px` }}>
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
      >
        <Typography variant="h4">Push Notifications senden</Typography>
        <FormControl fullWidth sx={{ m: 1 }}>
          <TextField
            id="outlined-basic"
            label="Titel"
            variant="outlined"
            sx={{ m: 1 }}
            value={messageData.title}
            onChange={action(event => {
              messageData.title = event.target.value;
            })}
          />
          <TextField
            id="outlined-basic"
            label="Body"
            variant="outlined"
            multiline
            rows={4}
            sx={{ m: 1 }}
            value={messageData.text}
            onChange={action(event => {
              messageData.text = event.target.value;
            })}
          />
          <TextField
            id="outlined-basic"
            label="Link"
            variant="outlined"
            sx={{ m: 1 }}
            defaultValue={messageData.link}
            onChange={action(event => {
              messageData.link = event.target.value;
            })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">https://</InputAdornment>
              ),
            }}
          />
          {Object.entries(Role).map((role, index) => (
            <FormGroup key={role[0]}>
              <FormControlLabel
                label={roleNames[index]}
                control={
                  <Checkbox
                    value={role}
                    onChange={event => {
                      const [, roleValue] = role;
                      messageData[roleValue] = event.target.checked;
                    }}
                  />
                }
              />
            </FormGroup>
          ))}
        </FormControl>
        <Button onClick={addNotificationEntry}>Senden</Button>
      </Box>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
        message={message}
      />
    </Container>
  );
});

export default NotificationsPage;
